import React, { useState, useMemo, useEffect, useRef } from 'react';
import ReactSelect, { components } from 'react-select';
import classNames from 'classnames';
import { bottom_arrow, empty } from './icons';
import { useInput } from '../form/hooks/useInput';
import useFormInstance from '../form/hooks/useFormInstance';
import { useTranslation } from '@weareconceptstudio/core';
import { useFormContext } from '../../FormProvider';
const Select = (props) => {
    const { name, placeholder, value, onChange, multiple = false, allowClear = false, allowSearch = false, disabled = false, loading = false, options: list = [], className, select_arrow = false, select_empty = false, optionKey, optionValue, optGroup, menuIsOpen = undefined, menuListMaxHeight = 200, } = props;
    const { selectIcon } = useFormContext();
    const { translate } = useTranslation();
    const formInstance = useFormInstance();
    let selectProps = {};
    if (formInstance == null) {
        const [val, setVal] = useState(value);
        const isInternalUpdate = useRef(false);
        useEffect(() => {
            if (!isInternalUpdate.current) {
                setVal(value);
            }
            isInternalUpdate.current = false;
        }, [value]);
        selectProps = {
            onChange: (e) => {
                onChange?.(e.value);
                setVal(e.value);
                isInternalUpdate.current = true;
            },
            value: val,
        };
    }
    else {
        const { field } = useInput({
            type: 'select',
            multiple,
            name,
            onChange,
        });
        selectProps = field;
    }
    //! ClassName
    const classString = classNames('react-select-container', {
        [className]: className,
    });
    //! Custom Placeholder
    const Placeholder = (props) => {
        return React.createElement(components.Placeholder, { ...props }, translate(placeholder));
    };
    //! Custom DropdownIndicator
    const DropdownIndicator = (props) => {
        return (React.createElement(components.DropdownIndicator, { ...props }, selectIcon || select_arrow || bottom_arrow));
    };
    //! Custom Components
    const customComponents = {
        Placeholder,
        DropdownIndicator,
    };
    //! Custom No Options Message
    const customNoOptionsMessage = () => {
        return (React.createElement("div", { className: 'no-options-block' },
            select_empty || empty,
            React.createElement("p", { className: `no-options` }, 'No Data')));
    };
    //! Custom Styles
    const customStyles = {
        menuList: (provided) => ({
            ...provided,
            maxHeight: `${menuListMaxHeight}px`,
        }),
    };
    const options = useMemo(() => {
        const newOptions = [];
        const labelKey = optionKey ?? 'name';
        const valueKey = optionValue ?? 'id';
        if (optGroup) {
            Object.keys(list).map((obj) => {
                newOptions.push({
                    label: obj,
                    options: list[obj].map((option) => {
                        return {
                            label: option[labelKey],
                            value: option[valueKey],
                        };
                    }),
                });
            });
        }
        else {
            list?.map((option) => {
                newOptions.push({
                    label: option[labelKey],
                    value: option[valueKey],
                });
            });
        }
        return newOptions;
    }, [list, optionKey, optionValue, optGroup]);
    return (React.createElement(ReactSelect
    // unstyled
    , { ...selectProps, options: options, isMulti: multiple, isLoading: loading, styles: customStyles, isDisabled: disabled, menuIsOpen: menuIsOpen, className: classString, isClearable: allowClear, isSearchable: allowSearch, components: customComponents, classNamePrefix: 'react-select', noOptionsMessage: customNoOptionsMessage, value: options.filter((opt) => multiple ? selectProps.value.includes(opt.value) : opt.value === selectProps.value) }));
};
if (process.env.NODE_ENV !== 'production') {
    Select.displayName = 'Select';
}
export default Select;
//# sourceMappingURL=index.js.map